// A helper function to fetch program info from scenario id
import { useAPI } from "/src/hooks/useAPI";

export async function fetchProgramFromScenarioId(brand, authToken, scenario_id) {
    const {callAPI} = useAPI();
    try {
        const response = await callAPI(`program_by_scenario?scenario_id=${scenario_id}`, {
            token: authToken,
        });

        return response;
    } catch (err) {
        console.error('Error fetching scenario:', err.message);
        return null;
    }
}
